import { Button, Card, Flex, Space, Stack, Text, Title } from '@mantine/core';
import dayjs from 'dayjs';
import React, { useEffect, useState } from 'react';
import { utils, writeFile } from 'xlsx';
import { useMutation } from '@tanstack/react-query';
import { listMissions } from '../../services/report-gamification';
import LabelDate from '../../components/fragments/LabelDate';
import DataTables from '../../components/elements/DataTables';
import LoadingIllustration from '../../components/fragments/IllustrationState/LoadingIllustration';

export default function MissionTable() {
  const [proses, setProses] = useState(false);
  const [missions, setMission] = useState([]);
  const [missionId, setMissionId] = useState(null);
  const renderDate = (item, key) => <LabelDate date={item[key]} />;

  const renderConvertExcel = () => {
    const filename = `List Mission - download at ${dayjs().toLocaleString()}`;

    const wb = utils.book_new();

    // Convert the JSON data to a worksheet
    const ws = utils.json_to_sheet(missions);

    // Add the worksheet to the workbook
    utils.book_append_sheet(wb, ws, 'Mission');

    // Write the workbook to a file
    // This will trigger a file download in the browser
    writeFile(wb, `${filename}.xlsx`);
  };

  const columnMission = [
    {
      heading: 'Mission Name',
      props: 'missionName',
      id: 'missionName',
      sortable: true
    },
    {
      heading: 'Mission Category',
      props: 'missionCategory',
      id: 'missionCategory',
      sortable: true
    },
    {
      heading: 'Mission Type',
      props: 'missionType',
      id: 'missionType',
      sortable: true
    },

    {
      heading: 'Action',
      props: (item) => (
        <Space>
          <Button
            color="purple"
            radius="md"
            onClick={() => {
              setMissionId(item.missionID);
              handleMission(item.missionID);
            }}
          >
            View User
          </Button>
        </Space>
      )
    }
  ];

  const columnMissionPicked = [
    {
      heading: 'Mission Name',
      props: 'missionName',
      id: 'badgeName',
      sortable: true
    },
    {
      heading: 'Binusian Name',
      props: 'namaBinusian',
      id: 'namaBinusian',
      sortable: true
    }

    // {
    //   heading: 'Timestamp',
    //   props: (item) => renderDate(item, 'timestamp'),
    //   id: 'timestamp',
    //   sortable: true
    // }
  ];

  useEffect(() => {
    handleMission(null);
  }, []);

  const handleMission = (passmissionId) => {
    setProses(true);
    const payload = {
      MissionID: passmissionId
    };
    fetchCategory.mutate(payload);
  };

  const fetchCategory = useMutation({
    mutationFn: listMissions,
    onSuccess: (data) => {
      setMission(data?.data?.data);
    },
    onError: (error: any) => {
      alert(error);
    },
    onSettled: () => {
      setProses(false);
    }
  });
  return (
    <Card>
      <Flex
        style={{
          justifyContent: 'space-between'
        }}
      >
        <Stack mb={10} gap={'xs'}>
          <Title order={4}>Report Gamification - Mission</Title>
          <Text size="sm">
            You can select one of the mission listed below to breakdown who has
            finish the mission.
          </Text>
        </Stack>
        <Flex>
          <Button
            color="teal"
            radius="md"
            onClick={() => {
              renderConvertExcel();
            }}
          >
            Download
          </Button>
          {missionId && (
            <Button
              color="gray"
              radius="md"
              ml={10}
              onClick={() => {
                setMissionId(null);
                handleMission(null);
              }}
            >
              Back
            </Button>
          )}
        </Flex>
      </Flex>
      {missions.length === 0 && proses ? (
        <LoadingIllustration />
      ) : (
        <DataTables
          columns={missionId ? columnMissionPicked : columnMission}
          loading={false}
          data={missions || []}
        />
      )}
    </Card>
  );
}
